import isEmpty from "lodash/isEmpty";
import { useLocation, useNavigate } from "react-router-dom";
import {
  EXTERNAL_PLAN_SELECTION_QUERY_PARAM_NAME,
  PRODUCT_ID_QUERY_PARAM_NAME,
} from "../../../constants/commonStrings";
import { PRICING_PAGE_PATH } from "../../../constants/env";
import { useCheckoutRedirectUrl } from "../../../features/pricing/hooks/useCheckoutRedirectUrl";
import type {
  INavigateToPricingPageOptions,
  IUseNavigateToPricingPage,
} from "./use-navigate-to-pricing-page.interface";

export function useNavigateToPricingPage(): IUseNavigateToPricingPage {
  const navigate = useNavigate();
  const location = useLocation();
  const { setPricingReturnPath } = useCheckoutRedirectUrl();

  function navigateToPricingPage(options?: INavigateToPricingPageOptions) {
    const { requestableFromTier, productId, replace } = options ?? {};
    const params = new URLSearchParams();

    if (requestableFromTier && !isEmpty(requestableFromTier)) {
      params.set(EXTERNAL_PLAN_SELECTION_QUERY_PARAM_NAME, requestableFromTier);
    }

    if (productId) {
      params.set(PRODUCT_ID_QUERY_PARAM_NAME, productId);
    }

    const queryString = params.toString();
    const pricingPageUrl = queryString ? `${PRICING_PAGE_PATH}?${queryString}` : PRICING_PAGE_PATH;

    let pathnameWithOptionalSearch = location.pathname;
    if (location.search) {
      pathnameWithOptionalSearch = `${location.pathname}${location.search}`;
    }

    setPricingReturnPath(pathnameWithOptionalSearch);

    navigate(pricingPageUrl, { state: { from: pathnameWithOptionalSearch }, replace });
  }

  return {
    navigateToPricingPage,
  };
}
